import { RequestBasePageIds, RequestBaseSet, RequestDelete, RequestDeleteIds, ResponseBasePage, ResponseBaseSet } from "src/app/modules/fwcore/models";
import { RateAdjustment } from "src/app/features/prob/models";

export class RequestRateAdjustment extends RequestBasePageIds {
  /**
   * The identifier of the tower for which adjustment formula are being requested.
   */
  towerId?: string | null = null;
}

export class ResponseRateAdjustment extends ResponseBasePage<RateAdjustment> {
}

export class RequestRateAdjustmentSet extends RequestBaseSet<RateAdjustment> {
}

export class ResponseRateAdjustmentSet extends ResponseBaseSet<RateAdjustment> {
}

export class RequestRateAdjustmentDelete extends RequestDeleteIds {
}

